import { Component, Input, HostBinding } from '@angular/core';
import { BadgeComponent } from '../../../badge/badge.component';
import { BadgeContentComponent } from '../../../badge/components/badge-content.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BadgeColor } from '../../../badge/badge.component';

type ChangeDirection = 'up' | 'down' | 'neutral';
type ChangeBadgeSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'span[app-card-indicators-change]',
  standalone: true,
  imports: [BadgeComponent, BadgeContentComponent, FontAwesomeModule],
  template: `
    <span app-badge class="card-indicators-change__badge" [color]="changeColor" [size]="badgeSize">
      <span app-badge-content class="card-indicators-change__content" direction="row">
        <fa-icon [icon]="changeIcon"></fa-icon>
        <ng-content></ng-content>
      </span>
    </span>
  `,
  styleUrls: ['card-indicators-change.component.scss'],
})
export class CardIndicatorsChangeComponent {
  @Input() direction: ChangeDirection = 'neutral';
  @Input() badgeSize: ChangeBadgeSize = 'sm';

  @HostBinding('class.card-indicators-change') readonly isCardIndicatorsChange = true;

  public get changeIcon(): string {
    if (this.direction === 'up') return 'arrow-up';
    if (this.direction === 'down') return 'arrow-down';
    return 'minus';
  }

  public get changeColor(): BadgeColor {
    if (this.direction === 'up') return 'success';
    if (this.direction === 'down') return 'danger';
    return 'neutral';
  }
}
